import { createRouter } from 'sv-router';
import Layout from '../pages/Layout.svelte';
import NotFound from '../pages/NotFound.svelte';
import ParticipantStats from '../pages/ParticipantStats.svelte';

export const { p, navigate, isActive, route } = createRouter({
  '/': () => import('../pages/Root.svelte'),
  '/game-info': () => import('../pages/GameInfo.svelte'),
  /* Static segments before `:id`, so `edit`/`new`/`json` win the match. */
  '/participants/edit': () => import('../pages/Participants.svelte'),
  '/participants/new': () => import('../pages/ParticipantEdit.svelte'),
  '/participants/json': () => import('../pages/ParticipantsJson.svelte'),
  '/participants/:id': ParticipantStats,
  '/participants/:id/group/:groupId': ParticipantStats,
  '/participants/:id/edit': () => import('../pages/ParticipantEdit.svelte'),
  '/groups': () => import('../pages/Groups.svelte'),
  '/groups/:id': () => import('../pages/GroupDetail.svelte'),
  '*': NotFound,
  layout: Layout,
});
